// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.meal_plans.`data`

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.Suppress
import kotlin.collections.List

@OptIn(InternalKtorfitApi::class)
public class _MealPlansApiClientImpl(
  private val _ktorfit: Ktorfit,
) : MealPlansApiClient {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override suspend fun getMealPlanInfos(): List<MealPlanInfoDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "view_models/mealplans.json")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<List<MealPlanInfoDto>>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _MealPlansApiClientProvider : ClassProvider<MealPlansApiClient> {
  override fun create(_ktorfit: Ktorfit): MealPlansApiClient = _MealPlansApiClientImpl(_ktorfit)
}

public fun Ktorfit.createMealPlansApiClient(): MealPlansApiClient = _MealPlansApiClientImpl(this)
